module.exports = __webpack_public_path__ + "static/img/record.f3e97de1.png";